module.exports = __webpack_public_path__ + "static/media/6.20_preview.8a512880.png";